import themeActionsTypes from '../actionTypes/themeActionsTypes';

export const setTheme = (payload) => ({ type: themeActionsTypes.SET_THEME, payload });
